<main>
  <header>
    <h1>Additional Owner Info</h1>
    <h2>U.S. Federal regulation requires us to collect information on individuals who own 25% or more of the business, as well as one control person who has significant responsibility to manage or direct the business. Please identify all individuals with 25% or more ownership and provide information for one control person, even if no individual meets the ownership threshold.</h2>
  </header>
  <form class="application-form" [formGroup]="form" (ngSubmit)="continue()" appPopulateForm [formType]="'additionalOwners'" [form]="form">

    <div class="form-row">
      <!-- First Name -->
      <div class="field first-name">
        <label for="firstName">First Name</label>
        <mat-form-field appearance="outline" hideRequiredMarker>
          <input matInput formControlName="firstName" required placeholder="Enter">
          @if (form.get('firstName')?.hasError('required')) {
            <mat-error>
              First Name is required
            </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- Middle Initial -->
      <div class="field middle-initial">
        <label for="middleInitial">Middle Initial</label>
        <mat-form-field appearance="outline" hideRequiredMarker>
          <input matInput formControlName="middleInitial" placeholder="(optional)" maxlength="1">
          @if (form.get('middleInitial')?.hasError('pattern')) {
            <mat-error>
              Please enter a single letter
            </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- Last Name -->
      <div class="field last-name">
        <label for="lastName">Last Name</label>
        <mat-form-field appearance="outline" hideRequiredMarker>
          <input matInput formControlName="lastName" required placeholder="Enter">
          @if (form.get('lastName')?.hasError('required')) {
            <mat-error>
              Last Name is required
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <!-- Email Address -->
    <div class="field">
      <label for="emailAddress">Email Address</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="emailAddress" required placeholder="Enter">
        @if (form.get('emailAddress')?.hasError('required')) {
          <mat-error>
            Email Address is required
          </mat-error>
        }
        @if (form.get('emailAddress')?.hasError('email')) {
          <mat-error>
            Please enter a valid email address
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Phone Number (renamed from Mobile Number) -->
    <div class="field">
      <label for="phoneNumber">Phone Number</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="phoneNumber" required type="tel" mask="(000) 000-0000" maxlength="15" inputmode="tel" (keypress)="onlyNumberKey($event)" placeholder="Enter">
        @if (form.get('phoneNumber')?.hasError('required')) {
          <mat-error>
            Phone Number is required
          </mat-error>
        }
        @if (form.get('phoneNumber')?.hasError('pattern')) {
          <mat-error>
            Phone Number must be 10 digits
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Date of Birth -->
    <div class="field">
      <label for="dateOfBirth">Date of Birth</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input
          matInput
          formControlName="dateOfBirth"
          required
          placeholder="__/__/____"
          mask="M0/d0/0000"
          [patterns]="dobReplacePattern"
          [dropSpecialCharacters]="false"
          appDateFormat
          (keydown)="onDobKeyDown($event)"
          (paste)="onDobPaste($event)">

        @if (form.get('dateOfBirth')?.hasError('required')) {
          <mat-error>
            Date of Birth is required
          </mat-error>
        }
        @if (form.get('dateOfBirth')?.hasError('invalid') || form.get('dateOfBirth')?.hasError('mask')) {
          <mat-error>
            Date of Birth is invalid
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- SSN -->
    <div class="field">
      <label for="ssn">SSN</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="ssn" mask="XXX-XX-XXXX" required [hiddenInput]="ssnMasked"
          [patterns]="ssnReplacePattern" placeholder="Enter"
          (keydown)="onSsnKeyDown($event)" (paste)="onSsnPaste($event)">
        <button type="button" mat-icon-button class="ssn-eye" matSuffix (click)="toggleSSNVisibility($event)" matTooltip="Show/Hide SSN">
          <img src="icons/lock.svg" alt="Lock Icon" />
        </button>
        @if (form.get('ssn')?.hasError('required')) {
          <mat-error>
            SSN is required
          </mat-error>
        }
        @if (form.get('ssn')?.hasError('mask') || form.get('ssn')?.hasError('pattern') || form.get('ssn')?.hasError('ssn')) {
          <mat-error>
            SSN must be in the format XXX-XX-XXXX
          </mat-error>
        }
      </mat-form-field>
      <mat-hint>We need to ask for your SSN to verify your information. We'll keep your data secure.</mat-hint>
    </div>

    <app-form-actions
      [isFormInvalid]="form.invalid"
      (continue)="continue()"
      (back)="goBack()"
      >
    </app-form-actions>
  </form>
</main>
